export const urlEncodedValue = value => {
  const decodedValue = window.decodeURIComponent(value),
      encodedValue = window.encodeURIComponent(value),
      alreadyEncoded = decodedValue !== value;

  if (alreadyEncoded) {
    return value;
  }

  return encodedValue;
};